/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import ICONS from "../../../../assets/Icons";
import InternalTransactionViewAll from "../../../../containers/Transactions/InternalTransactions/InternalTransactionViewAll";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";

const BACKDROP_OPACITY_CLASS = {
  dark: "bg-opacity-dark-opacity",
  light: "bg-opacity-light-opacity",
};

const InternalTransactionViewAllPopup = ({
  /* visibility */
  isOpen = true,
  onClose,

  /* header */
  title = "",
  subtitle = "",
  headerIcon, // e.g. ICONS.ALERT

  /* redirect button (top right) */
  showRedirectButton = false,
  onRedirect,

  /* footer (text + button) */
  showFooter = false,
  footerTitle = "",
  footerButtonText = "Proceed",
  onFooterButtonClick,
  footerButtonColor = "var(--negative-act)",
  footerButtonTextColor = "var(--text-primary)",
  footerButtonHoverOption = "dark",
  footerButtonOutlineColor = "",
  isFooterButtonDisabled = false,

  /* backdrop / container (all off by default) */
  showBackdrop = false,
  backdropOpacity = "dark", // "dark" | "light"
  zIndexClass = "z-z-index-max",
  className = "",
  stopClickPropagation = false,

  /* content */
  ContentComponent = InternalTransactionViewAll,
  contentProps = {}, // forwarded as-is to ContentComponent
  children, // rendered instead of ContentComponent when provided

  /* extra LargePopupRedirect props; override the defaults above */
  popupProps = {},

  /* behaviour */
  disableEntitySwitcher = false,
  onUnmount,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isOpen || !disableEntitySwitcher) return;

    dispatch(disableSwitcher());
    return () => {
      dispatch(enableSwitcher());
      onUnmount?.();
    };
  }, [isOpen]);

  if (!isOpen) return null;

  let popup = (
    <LargePopupRedirect
      /* header */
      headerTitle={title}
      headersubtext={subtitle}
      isHeaderImgNeed={!!headerIcon}
      ShowIcon={headerIcon}
      /* redirect button */
      isfullViewrequired={showRedirectButton}
      fullviewisDisabled={false}
      fullviewhoverOption="white"
      fullviewenabledTextColor="var(--text-primary)"
      fullviewenabledBgColor="var(--primary-nav)"
      fullviewdisabledBgColor="var(--text-disabled)"
      fullviewicon={ICONS?.REDIRECT}
      fullviewhandleFunction={onRedirect}
      /* close button */
      closeiconhandleFunction={onClose}
      closeiconisLoading={false}
      closeiconisDisabled={false}
      closeiconenabledBgColor="var(--primary-nav)"
      closeicondisabledBgColor=""
      closeiconhoverOption="white"
      closeiconbtnType="button"
      closeiconbuttonRef={null}
      closeicontitle="Close"
      closeicon={ICONS?.CLOSE}
      /* footer */
      isbottomSectionneed={showFooter}
      bottomHeaderTextNeed={showFooter && !!footerTitle}
      bottomHeaderText={footerTitle}
      confirmbtnrequired={showFooter}
      btnType="button"
      btnText={footerButtonText}
      handleFunction={onFooterButtonClick}
      enabledBgColor={footerButtonColor}
      enabledTextColor={footerButtonTextColor}
      hoverOption={footerButtonHoverOption}
      outLineColor={footerButtonOutlineColor}
      fullWidthRequired={false}
      isDisabled={isFooterButtonDisabled}
      /* overrides */
      {...popupProps}
    >
      {children ?? <ContentComponent {...contentProps} />}
    </LargePopupRedirect>
  );

  if (stopClickPropagation || className) {
    popup = (
      <div
        onClick={stopClickPropagation ? (e) => e.stopPropagation() : undefined}
        className={`w-width-full h-height-full ${className}`}
      >
        {popup}
      </div>
    );
  }

  if (!showBackdrop) return popup;

  return (
    <div
      className={`fixed top-top-base left-left-base w-screen h-screen bg-PopUp-BackDrop ${BACKDROP_OPACITY_CLASS[backdropOpacity]} ${zIndexClass}`}
    >
      {popup}
    </div>
  );
};

export default InternalTransactionViewAllPopup;
